import auth from './AuthService';
import { roles as constRoles } from './constants';

const AuthenticateChildren = ({ roles, children, ignoreViewAs }) => {
    if (auth.getInstance().isAuthenticated()) {
        if (roles) {
            const instance = auth.getInstance();
            const user = instance.getUser();
            const userRoles = (user || {}).roles || [];
            if (userRoles.length > 0) {
                if (!ignoreViewAs && instance.isViewingAsClient()) {
                    const ind = userRoles.indexOf(constRoles.Admin);
                    if (ind > -1) {
                        userRoles.splice(ind, 1);
                        userRoles.push(constRoles.Owner);
                    }
                }
            }

            let roleIntersection = roles.filter(r => userRoles.includes(r));
            if (roleIntersection.length > 0) {
                return children;
            }
        }
        else {
            return children;
        }
    }

    return null;
};

export default AuthenticateChildren;


// WEBPACK FOOTER //
// ./src/AuthenticateChildren.js